import { Collapse } from 'antd';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const StyledCollapse = ({ children, ...res }) => {
  return (
    <Collapse
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 12,
      }}
      ghost
      expandIconPosition="end"
      expandIcon={({ isActive }) => {
        return (
          <ArrowDownIcon
            style={{
              transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
              transitionTimingFunction: 'ease',
              transitionDuration: '0.1s',
              position: 'absolute',
              right: 0,
              top: 24,
            }}
          />
        );
      }}
      {...res}
    >
      {children}
    </Collapse>
  );
};

export default StyledCollapse;

export const CollapsePanelWrapper = styled(CollapsePanel)<{
  collapseContentBoxCSS?: CSSProperties;
}>`
  .ant-collapse-header,
  .ant-collapse-content-box {
    padding: 12px 0px !important;
    ${props => ({ ...props.collapseContentBoxCSS })}
  }
  .ant-collapse-header {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    align-items: center;
  }
  .ant-collapse-header-text {
    font-weight: 600;
    font-size: 16px;
    margin-right: 28px;
  }
`;
